import { NgModule } from '@angular/core';
import { MatCommonModule } from '@angular/material/core';
import { MatTooltipModule as TModule } from '@angular/material/tooltip';

import { UiTooltipDirective } from './tooltip-override.directive';

@NgModule({
    imports: [
        TModule,
        MatCommonModule,
    ],
    exports: [UiTooltipDirective],
    declarations: [UiTooltipDirective],
})
export class MatTooltipModule { }
